import { SessionModel } from '../../core/state';

/** Determines whether a component can use the "Unsaved Changes" - an option within the auto-recovery modal. */
export const canUseUnsavedChanges = (session: SessionModel, isStoreDirty: boolean) =>
  session.needsAutoRecoveryDecision === false && !!session.cached1003?.snapshot?.Value && isStoreDirty;
